import React, { useState, useEffect } from "react";
import {
  Table,
  Avatar,
  Typography,
  Button,
  Input,
  Space,
  Modal,
  message,
} from "antd";
import { UserOutlined, EyeOutlined, HistoryOutlined } from "@ant-design/icons";
import {  companyService } from "../../app/services";

const { Title } = Typography;

const ClientsPage = ({ company }) => {
  const [clients, setClients] = useState([]);
  const [search, setSearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [appointments, setAppointments] = useState([]);

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    try {
      const response = await companyService.getCompanyEmployees(company);
      setClients(response.data || []);
    } catch (err) {
      console.error(err);
      message.error("Failed to load clients");
    }
  };

  // const fetchClientAppointments = async (clientId) => {
  //   try {
  //     const response = await appointmentService.getClientAppointments(clientId);
  //     setAppointments(response.data || []);
  //     setIsModalOpen(true);
  //   } catch (err) {
  //     console.error(err);
  //     message.error("Failed to load appointments");
  //   }
  // };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <Space>
          <Avatar
            src={record.avatar}
            icon={!record.avatar && <UserOutlined />}
            style={{ backgroundColor: !record.avatar ? "#7265e6" : undefined }}
          >
            {!record.avatar && text[0]}
          </Avatar>
          <span>{text}</span>
        </Space>
      ),
    },
    {
      title: "Contact",
      dataIndex: "contact",
      key: "contact",
      render: (contact) => (
        <span style={{ color: "#1677ff" }}>{contact || "—"}</span>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (email) => email || "—",
    },
    {
      title: "Last Appointment",
      dataIndex: "lastAppointment",
      key: "lastAppointment",
      render: (appt) =>
        appt ? new Date(appt).toLocaleDateString() : "No appointments",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<HistoryOutlined />}
            
          >
            History
          </Button>
          <Button
            type="link"
            icon={<EyeOutlined />}
            onClick={() => {
              setSelectedClient(record);
              setIsModalOpen(true);
            }}
          >
            Details
          </Button>
        </Space>
      ),
    },
  ];
// onClick={() => fetchClientAppointments(record.id)}
  return (
    <div style={{ padding: "24px" }}>
      <Title level={3} style={{ marginBottom: 24 }}>
        Clients
      </Title>

      <Space style={{ marginBottom: 16, width: "100%" }} align="center">
        <Input.Search
          placeholder="Search clients"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ maxWidth: 300 }}
        />
      </Space>

      <Table
        rowKey="id"
        columns={columns}
        dataSource={clients.filter((c) =>
          c.name.toLowerCase().includes(search.toLowerCase())
        )}
        pagination={{ pageSize: 10 }}
        bordered={false}
        style={{
          background: "white",
          borderRadius: 8,
          boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
        }}
      />

      {/* Modal for details or appointment history */}
      <Modal
        title={selectedClient ? "Client Details" : "Appointments"}
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setSelectedClient(null);
          setAppointments([]);
        }}
        footer={null}
        width={700}
      >
        {selectedClient && (
          <div>
            <p>
              <strong>Name:</strong> {selectedClient.name}
            </p>
            <p>
              <strong>Contact:</strong> {selectedClient.contact}
            </p>
            <p>
              <strong>Email:</strong> {selectedClient.email}
            </p>
          </div>
        )}

        {appointments.length > 0 && (
          <div>
            <Title level={5}>Appointments</Title>
            <ul>
              {appointments.map((a) => (
                <li key={a.id}>
                  {new Date(a.start).toLocaleDateString()} - {a.serviceName} (
                  {a.status})
                </li>
              ))}
            </ul>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ClientsPage;
